import { Injectable, inject } from '@angular/core';
import { HttpService } from '@nha/api/shared';
import { CoreApiConfiguration } from '../core-api-configuration.class';

@Injectable({
	providedIn: 'root'
})
export class DocumentCacheService extends HttpService {
	constructor() {
		const config = inject(CoreApiConfiguration);

		super(config, 'documentCache');
	}

	getDocumentByID(documentID: string) {
		return this.http.get(`${this.serviceUrl}/${documentID}`, {
			responseType: 'arraybuffer'
		});
	}
}
